import React from 'react'

const Button = ({className, onClick, children}) => {
    return (
        <React.Fragment>
            <button className={'link dim br1 dib mw4 shadow-4 ph3 pv2 ma1 white bg-light-blue bw0 ' + (className || '')}
                style ={{background: '#2196f3'}}
                onClick={ onClick }>
                { children }
            </button>
        </React.Fragment>
    )
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button.js